// frontend/src/services/instructions/instructionsService.js
import api from '../api';
import errorService from '../error/errorService';

/**
 * Instructions Service - Handles translation instructions operations
 */
class InstructionsService {
  // Default instructions as specified in requirements
  DEFAULT_INSTRUCTIONS = `Don't remove or change any markdown or LaTeX annotation or math.
The values in \\index{...} must be translated too.
Don't translate math and equations.
Always use $$ and $ as delimiters for LaTeX the way they are used in the input.`;

  /**
   * Get instructions for a project
   * @param {string} projectId - The ID of the project
   * @returns {Promise<string>} - Promise that resolves with the instructions text
   */
  async getInstructions(projectId) {
    try {
      const response = await api.get(`/projects/${projectId}/instructions`);
      return response.data?.text || this.DEFAULT_INSTRUCTIONS;
    } catch (error) {
      console.error("Error fetching instructions:", error);
      // Return default instructions on error rather than breaking the app
      return this.DEFAULT_INSTRUCTIONS;
    }
  }

  /**
   * Update instructions for a project
   * @param {string} projectId - The ID of the project
   * @param {string} text - The instructions text
   * @returns {Promise<Object>} - Promise that resolves when instructions are updated
   */
  async updateInstructions(projectId, text) {
    try {
      // Ensure text is not empty
      const textToSave = text.trim() ? text : this.DEFAULT_INSTRUCTIONS;
      
      const response = await api.post(`/projects/${projectId}/instructions`, { text: textToSave });
      return response.data;
    } catch (error) {
      return errorService.handleApiError(error, 'Failed to update instructions');
    }
  }

  /**
   * Get default instructions
   * @returns {string} - The default instructions text
   */
  getDefaultInstructions() {
    return this.DEFAULT_INSTRUCTIONS;
  }
}

export default new InstructionsService();